import { RoutePreferences } from './RoutePreferences'

export default RoutePreferences
